import React from 'react';
export const WelcomeScreenClassicEditor = () => {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    height: "100",
    width: "120",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "clip-path": "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.627 66.7c-3.35-4.63-1.35-13.3 4.37-18.92a29.66 29.66 0 0 1 1.61-1.45 5.69 5.69 0 0 1-.56-3.66c.67-4.44 5.28-8.45 12.24-10.67l.31.95c-9.77 3.18-11.32 8.41-11.56 9.93a4.72 4.72 0 0 0 .38 2.88c3.83-2.81 7.2-3.12 8.75-2.52a1.76 1.76 0 0 1 1.26 1.51c.05 1-.89 2-2.64 2.93-2.66 1.35-5.18 1.4-6.91.14a4.5 4.5 0 0 1-.69-.62 20 20 0 0 0-1.49 1.34c-5.29 5.16-7.28 13.39-4.26 17.58l-.81.58zm7.36-20.17c.143.161.304.305.48.43 1.42 1 3.56.95 5.87-.22 1.57-.8 2.11-1.55 2.09-2s-.4-.54-.63-.63c-1.29-.49-4.32-.11-7.81 2.42z",
    fill: "#192c55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.38 7.73l-2.89 26.75-12.88 8.44-.21.14-.18.12-.03.73-.01.14-.97 22.71-13.2 8.72-1.02 23.57-72.7-2.61.99-23.04.02-.54.63-.42L24.5 64.1l1.52-23.88.67-.42 12.01-7.94L41.66 4.1l72.72 2.6v1.03z",
    fill: "#c2e2ff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.61 42.92l-.21.14-.18.12-.03.73-9.95-.49.04-.72.01-.28 10.32.5zM22.77 73.06l-.05.99-11.46-.57.02-.53.63-.42 10.86.53z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.712 19.524c-1.31-5.35-6.721-8.577-12.084-7.21s-8.65 6.813-7.34 12.162 6.721 8.578 12.084 7.21 8.65-6.813 7.34-12.162z",
    fill: "#116dff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.876 21.659c-.431-.066-.729-.443-.662-.842s.476-.679.907-.613c2.618.377 5.236.391 7.847 0 .431-.066.84.207.915.613.067.399-.223.783-.662.849l-2.864.281a16.77 16.77 0 0 0 1.205 4.814c.156.384-.052.805-.461.953s-.87-.044-1.026-.428a18.54 18.54 0 0 1-1.026-3.374c-.231 1.144-.58 2.274-1.026 3.374-.156.384-.617.576-1.026.428s-.617-.569-.461-.953c.64-1.558 1.049-3.168 1.205-4.822l-2.856-.273-.007-.007zm4.172-2.149c.766 0 1.383-.613 1.383-1.373s-.617-1.373-1.383-1.373-1.383.613-1.383 1.373.617 1.373 1.383 1.373z",
    "fill-rule": "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.645 82.063c2.615-3.424 7.417-4.15 10.727-1.623s3.873 7.352 1.258 10.775-7.417 4.15-10.727 1.623-3.873-7.352-1.258-10.775zm14.261-30.749c2.615-3.423 7.417-4.15 10.727-1.622s3.873 7.352 1.258 10.775-7.417 4.15-10.727 1.622-3.873-7.352-1.258-10.775z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#192c55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.038 81.328l-.6.8 13.118 9.842.6-.8-13.118-9.842zm2.753-4.506l-.253.967 9.151 2.396.253-.967-9.151-2.396z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#28bf9a",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.891 84.307l1.013 1.004-4.712 4.383-2.729-2.72 1.041-.975 1.721 1.721 3.667-3.413zm14-31l1.013 1.004-4.712 4.383-2.729-2.72 1.041-.975 1.721 1.721 3.666-3.413z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.85 31.24l4.56 36.46-5.5.11-4.997-24.005c-2.21 12.571-11.741 22.642-13.22 24.142l-.093.094-.019.019-.065.064-.016.016-3.5-4.8 2.64-4a43.36 43.36 0 0 0 7.66-23.9l4.825-.222-.515-2.478 8.24-1.5zM71.51 11.7l6.41.34.37 1.72-5.76 2.78-1.02-4.84z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.84 69.79h-9.59l-.44-2.47 6.46.16A4 4 0 0 1 57.39 69a3.61 3.61 0 0 1 .45.79z",
    fill: "#192c55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.51 11.7l-44.7 7.96 1.13 5.1 44.59-8.22-1.02-4.84z",
    fill: "#ffd527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.92 12.04l.37 1.72 3.17-1.52-3.54-.2z",
    fill: "#192c55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 20.53l1 5.13 5.28-.95-1.14-5.1-5.14.92z",
    fill: "#ffb6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.64 19.482l-.983.184.97 5.19.983-.184-.969-5.19z",
    fill: "#1d2d54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.49 16.55a3.62 3.62 0 1 0 0-7.24 3.62 3.62 0 1 0 0 7.24z",
    fill: "#ffb6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.89 12.51a3.63 3.63 0 0 0 3.17 4l.85-7.2a3.62 3.62 0 0 0-4.02 3.2z",
    fill: "#192c55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.29 14.84a1 1 0 1 0 0-2 1 1 0 1 0 0 2z",
    fill: "#ffb6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.56 14.3a2.65 2.65 0 1 0 0-5.3 2.65 2.65 0 1 0 0 5.3z",
    fill: "#192c55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.889 24.067l6.124-6.124 3.472 3.472-6.123 6.124a2.46 2.46 0 0 1-3.479 0 2.46 2.46 0 0 1 .007-3.472z",
    fill: "#5dbc9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.58 69.79l-3.64-5 1.56-2.11 3.36 4.81 2.1.34a1.88 1.88 0 0 1 1.55 2h-4.93v-.04z",
    fill: "#192c55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.38 35.43H36.3l2.2-14.84a5.62 5.62 0 0 1 5.41-4.11 5.61 5.61 0 0 1 5.59 5.2l-.12 13.75z",
    fill: "#5dbc9c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffb6ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.08 16.12l-3.13 1.62-1.18-1.47 4.31-.75v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27 16.95l2.29 3.45 3.8-2.91-1.02.14-5.07-.68z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.6 23.92l-7.79-2.85.79-4.32 9.17 3.6 6.52-3.43 2.3 3.46-6.27 3.24a5.84 5.84 0 0 1-4.72.3z",
    fill: "#5dbc9c"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v120H0z",
    fill: "#fff",
    transform: "translate(0 -10)"
  }))));
};
//# sourceMappingURL=welcome-screen-classic-editor.js.map